import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { TaskDtoKeysEnum } from '@zaoblako/shared/modules/task/enum/task-dto-keys.enum';

import * as yup from 'yup';

/** BRS tasks priority find response body - DTO signature */
export interface TaskPriorityFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  /** Display name */
  name: string;
  /** Description */
  description: string;
  /** Color */
  color: string;
  /** Order */
  order: number;
}

/** BRS tasks priority find response body - DTO schema */
export const TaskPriorityFindDto = SerdeDtoClass.create<TaskPriorityFindInterface>(TaskDtoKeysEnum.TASKS_PRIORITY_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  name: {
    sortable: true,
    label: 'Имя',
    serializer: yup.string(),
  },
  description: {
    label: 'Описание',
    serializer: yup.string(),
  },
  color: {
    label: 'Цвет',
    serializer: yup.string(),
  },
  order: {
    label: 'Сортировка',
    serializer: yup.number(),
  },
});
